import { useState } from 'react';
import { connect } from 'react-redux';
import { Alert, Forms, Loader } from '../..';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import ContactoForm from '../../../pages/admin/config/contactos/form';
import API from '../../../services/api';
import { IContacto } from '../../../services/api/entity/model';
import Service from '../../../services/common/services/formservice';
import { CardHelper, ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Accordion, AccordionTab, Button, Column, DataTable, Dialog } from '../../prime';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import CnetPersonaButton from '../../cnet/CnetPersonaButton';
import Question from '../../question';

const CloseCard = (forceRefresh?: boolean) => (window as any).CloseCard(forceRefresh);

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

let contactoForm : Service<IContacto> | undefined = undefined;

function CardSeccionContacto({ storage, t,
  data,
  onUpdateFields,
} : IProps) {
  const [ contactoDialog, setContactoDialog ] = useState<{ saving?: boolean, id?: number } | undefined>(undefined);
  const [ questionReemitir, setQuestionReemitir ] = useState<undefined | 'ask' | 'procesing'>(undefined);

  const onContactoSave = (service: Service<IContacto>|undefined) => {
    const dto = service?.getEntity();
    if (!dto?.success || !dto.data) return;
    setContactoDialog({ id: contactoDialog?.id, saving: true });

    API.entity().contacto().upsert(dto.data!).then(upd => {
      Alert.reponse(upd);
      
      if (upd.success && !!data?.operacioncontactos && !!dto.data) {
        Alert.info(t("Seccion.Contacto.Dialog.Contacto.Guardar.Success.Titulo"), t("Seccion.Contacto.Dialog.Contacto.Guardar.Success.Msg", { id: dto.data.nombre }));
        onUpdateFields([
          { field: `operacioncontactos.[*idcontacto===${dto.data.id}].contacto.tipo`, value: dto.data.tipo },
          { field: `operacioncontactos.[*idcontacto===${dto.data.id}].contacto.nombre`, value: dto.data.nombre },
          { field: `operacioncontactos.[*idcontacto===${dto.data.id}].contacto.apellido`, value: dto.data.apellido },
          { field: `operacioncontactos.[*idcontacto===${dto.data.id}].contacto.telefono`, value: dto.data.telefono }
        ])

        if (CardHelper.mustAskForReemitir(data, ['force']))
          setQuestionReemitir('ask');
      }
    })
    .catch(err => Alert.error(t("Seccion.Contacto.Dialog.Contacto.Guardar.Error.Titulo"), err))
    .finally(() => {
      console.log("QUE PASA CON LOS FINNALY", CardHelper.estado(data))
      setContactoDialog(undefined);
    })
  }


  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Contacto}`)}</div>
    
    <Accordion activeIndex={[0,1,2]} multiple>
      <AccordionTab header={t("Seccion.Contacto.SubSection.Emails")}>
        <div className='p-grid'>
        <div className='p-col-12 p-lg-6 p-p-2'>
            <Forms.Input 
              title={t("Seccion.Field.cotizacion.email")}
              className={styles["fix-form-component"]}
              value={data?.cotizacion?.email} 
              //onChange={(v,e) => onUpdateField('cotizacion.email', v)}
            />
          </div>
          <div className='p-col-12 p-lg-6 p-p-2'>
            <Forms.Input 
              title={t("Seccion.Field.cotizacion.mailme")}
              className={styles["fix-form-component"]}
              value={data?.cotizacion?.mailme ?? data?.cotizacion?.descuentoemailme} 
              //onChange={(v,e) => onUpdateField('cotizacion.mailme', v)}
            />
          </div>
        </div>
      </AccordionTab>
      <AccordionTab header={t("Seccion.Contacto.SubSection.Telefonos")}>
        <div className='p-grid'>
          <div className='p-col-12 p-lg-6 p-p-2'>
            <Forms.Input 
              title={t("Seccion.Field.cotizacion.whatsapp")}
              className={styles["fix-form-component"]}
              value={data?.cotizacion?.whatsapp} 
              //onChange={(v,e) => onUpdateField('cotizacion.whatsapp', v)}
            />
          </div>
          <div className='p-col-12 p-lg-6 p-p-2'>
            <Forms.Input 
              title={t("Seccion.Field.cotizacion.callme")}
              className={styles["fix-form-component"]}
              value={data?.cotizacion?.callme ?? data?.cotizacion?.descuentocallme} 
              //onChange={(v,e) => onUpdateField('cotizacion.callme', v)}
            />
          </div>
        </div>
      </AccordionTab>
      <AccordionTab header={t("Seccion.Contacto.SubSection.Contactos")}>
        <div className="datatable-responsive-demo">
          <DataTable value={data?.operacioncontactos ?? [] /*?.map(p => p.contacto ?? p) ?? []*/} className="p-datatable-responsive-demo">
            <Column field='tipo' header={t("Seccion.Field.operacioncontactos.contacto.tipo")} 
              body={row => <>{!window.app_usems ? row.tipo : t(`@Entity#Contacto.Tipo.${row.tipo}`) }</>}
            />
            <Column field='nombre' header={t("Seccion.Field.operacioncontactos.contacto.nombre")} />
            <Column field='apellido' header={t("Seccion.Field.operacioncontactos.contacto.apellido")} />
            {/*<Column field='telefono' header={t("Seccion.Field.operacioncontactos.contacto.telefono")} />*/}
            <Column 
              style={{ width: 50 }} 
              body={(row,col) => <CnetPersonaButton 
                t={t} idPersona={row.idpersona} 
                disabled={!CardHelper.allowEdit(data, 'force')}
                //className='p-button-rounded p-button-outlined p-button-sm'
                className='p-button-text p-button-sm'
                //disabled={!Security.HasOneRolOf([Roles.Operador, Roles.Admin, Roles.AdministradorMarca])}
                formMode='sidebar-right' 
                //icon={null}
                //label="editar"
                onSave={(entity) => {
                  row.nombre = entity.nombre;
                  row.apellido = entity.apellido;
                  row.telefono = (entity.telefonos??[]).length >= 1 ? entity.telefonos![0].numero : undefined;

                  onUpdateFields([
                    { field: "random", value: Math.random() }
                  ]);
                  
                  //preguntar si quieren regenerar el voucher
                  if (CardHelper.mustAskForReemitir(data, ['force']))
                    setQuestionReemitir('ask');
                }} 
              />
              }
            />
          </DataTable>
        </div>
        <Dialog 
          visible={!!contactoDialog} 
          onHide={() => setContactoDialog(undefined)} 
          header={t("Seccion.Contacto.Dialog.Contacto.Title")} 
          style={{ width: 600, maxWidth: '100%' }} 
          footer={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
            <Loader loading={contactoDialog?.saving}>
              <Button icon="pi pi-times" label={t("Seccion.Contacto.Dialog.Contacto.Cerrar")} className="p-button-secondary" onClick={() => setContactoDialog(undefined)} tooltip={t("Seccion.Contacto.Dialog.Contacto.Cerrar.Tooltip")} tooltipOptions={{ position: 'top' }} style={{ marginLeft: 10 }} />
              <Button icon="pi pi-save" disabled={!CardHelper.allowEdit(data, 'force')} label={t("Seccion.Contacto.Dialog.Contacto.Guardar")} className="p-button-primary" tooltip={t("Seccion.Contacto.Dialog.Contacto.Guardar.Tooltip")} tooltipOptions={{ position: 'top' }} onClick={() => onContactoSave(contactoForm)} />
            </Loader>
          </div>}
        >
          <Loader loading={contactoDialog?.saving}>
            <ContactoForm id={contactoDialog?.id} refService={e => contactoForm = e} />
          </Loader>
        </Dialog>
      </AccordionTab>
    </Accordion>
    
    <Question
      text={t("Question.ReEmitirVoucher.Text")}
      title={t("Question.ReEmitirVoucher.Title")}
      ok_text={t("Question.ReEmitirVoucher.Ok")}
      cancel_text={t("Question.ReEmitirVoucher.Cancel")}
      visible={!!questionReemitir}
      working={questionReemitir === 'procesing'}
      ok={() => {
        setQuestionReemitir('procesing');
        CardHelper.reemitirIfAllow(data, ['force']).then(res => {
          if (!res.success) {
            setQuestionReemitir(undefined);
            return Alert.reponse(res);
          }
          setQuestionReemitir(undefined);
          CloseCard(true);
        }).catch(ex => Alert.exception(t, ex))
      }}
      onClose={() => setQuestionReemitir(undefined)}
    />
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionContacto);
